import {
  refreshDeductionWorkspaceAtom,
  RefreshDeductionWorkspaceOptions,
} from "@/store/deduction/refreshDeductionWorkspace.actions";
import { useSetAtom } from "jotai";
import { useCallback } from "react";

export function useRefreshDeductionWorkspace() {
  const refresh = useSetAtom(refreshDeductionWorkspaceAtom);

  return useCallback(
    (options: boolean | RefreshDeductionWorkspaceOptions = true) => refresh(options),
    [refresh]
  );
}
